export default {"src":"/_next/static/media/xtz.7909ebfe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};